import AxiosConfig from "@/config/axiosConfig/AxiosConfig";
import config from "@/config";

const cvService = {
    getListCV : async (params) => {
        try{
            const resp = await AxiosConfig.get(config.api.cv + '/CvList', {params});
            return resp.data;
        }catch (err) {
            console.log(err);
            return Promise.reject(err);
        }
    },
    getCvAvatars : async (params) => {
        try{
            const resp = await AxiosConfig.get(config.api.cv + '/getAvatar', {params, timeout: 10000});
            return resp.data;
        }catch (err) {
            console.log(err);
            return Promise.reject(err);
        }
    },

    getFieldSearch : async (pageNo) => {
        try{
            const resp = await AxiosConfig.get(config.api.cv + `/CvFieldSearch?${pageNo}`);
            return resp.data;
        }catch (err) {
            console.log(err);
            return Promise.reject(err);
        }
    },

    getCvNoiBat : async () => {
        try{
            const resp = await AxiosConfig.get(config.api.cv + '/ListCvNoiBat');
            return resp.data;
        }catch (err) {
            console.log(err);
            return Promise.reject(err);
        }
    },

    getDetailCv : async (id) => {
        try{
            const resp = await AxiosConfig.get(config.api.cv + `/ho-so-online/${id}`);
            return resp.data;
        }catch (err){
            console.log(err);
            return Promise.reject(err);
        }
    }
}

export default cvService;